<script>
  import { paginateItems } from "$lib/components/Pagination/Pagination.svelte";
  import DonorNames from "./Contributors/DonorNames.svelte";
  import {
    Pagination,
    CenteredLayout,
    GridContainer,
    Search
  } from "@ObamaFoundation/of-design-system";

  export let items = [];
  export let itemsPerPage = 10;
  export let formName;
  export let containerRef;
  export let formSubmitErrorMessage;
  export let pageNumber = 1;

  $: ({ numOfPages, paginatedItems } = paginateItems(items, itemsPerPage));
  $: activeItems = paginatedItems?.[0] ?? [];
  function onNavigate(event) {
    let pageNumber = event.detail.page;
    activeItems = paginatedItems[pageNumber - 1];
    window.scrollTo({
      top: containerRef?.offsetTop || 0,
      behavior: "smooth"
    });
  }
</script>

<CenteredLayout title="$200 to $9,999" class="mb-7.5 lg:mb-15">
  <div bind:this={containerRef}>
    <Search
      errorMessage={formSubmitErrorMessage}
      searchId={`${formName}-searchableList-searchBar`}
      on:clear
      on:submit
    />
    <DonorNames
      contributors={activeItems}
      liClasses="border-b-thin body-md py-7.5 last:border-b-0"
    />
  </div>
</CenteredLayout>
<GridContainer>
  <Pagination
    class="mb-100"
    on:navigate={onNavigate}
    totalPages={numOfPages}
    initialActivePage={pageNumber}
  />
</GridContainer>
<div aria-live="polite" aria-atomic="true" class="sr-only">Found {items.length} items</div>
